module.exports = __webpack_public_path__ + "img/badge_import_caricamento_tracciato.cc5fcbe2.jpg";